import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_DATA,
  REQUEST_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
  REQUEST_TE_SBS_DATA,
  RECEIVE_TE_SBS_DATA,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingTeSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  teSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  factorOptions: [
    {
      label: "TOTAL",
      value: "TOTAL",
    },
    {
      label: "LOCAL",
      value: "LOCAL",
    },
    {
      label: "EXCESS",
      value: "EXCESS",
    },
    {
      label: "CURRENCY",
      value: "CURRENCY",
    },
    {
      label: "SPECIFIC",
      value: "SPECIFIC",
    },
    {
      label: "SPREAD",
      value: "SPREAD",
    },
    {
      label: "YIELD",
      value: "YIELD",
    },
    {
      label: "OTHER",
      value: "OTHER",
    },
  ],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }

    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }

    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }

    case COMMIT_SELECTIONS:
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    case REQUEST_DATA:
      state.fetchingData[action.payload.summary] = true;
      state.data[action.payload.summary] =
        defaultState.data[action.payload.summary];
      break;

    case RECEIVE_DATA:
      state.fetchingData[action.payload.summary] = false;
      state.data[action.payload.summary] = action.payload.data;
      break;

    case REQUEST_TE_SBS_DATA:
      state.fetchingTeSbsData[action.payload.summary] = true;
      state.teSbsData[action.payload.summary] =
        defaultState.teSbsData[action.payload.summary];
      break;

    case RECEIVE_TE_SBS_DATA:
      state.fetchingTeSbsData[action.payload.summary] = false;
      state.teSbsData[action.payload.summary] = action.payload.data;
      break;
    default:
      return state;
  }
});
export default reducer;
